import { useHistory } from 'react-router-dom'

import { Paths } from '../config/routes'
import { useUser } from '../contexts/user/user-context'
import { authService } from '../lib/auth-service'

export function useSignOut() {
    const history = useHistory()
    const { clearUser } = useUser()

    async function signOut() {
        try {
            await authService.signOut()
            clearUser()
            history.push(Paths.SIGN_IN)
        } catch (err) {
            throw new Error('Sign out failed')
        }
    }

    return signOut
}
